import { EnvironmentService } from './environment/environment.service';

const LOADED_APP_KEY = 'loadedApp';

// This shouldn't be used as a service as doing so might lead to cyclic reference errors
export class LoadedMfeHelper {
  /**
   * This sets the app that were loaded to the sessionStorage for later use
   */
  static setLoadedAppWithValidation(
    appName: string,
    environmentService: EnvironmentService
  ): void {
    const loadedApp = LoadedMfeHelper.getLoadedApp();
    if (loadedApp !== appName) {
      if (!environmentService.getAppByKey(appName)) {
        appName = environmentService.getDefaultAppKey() ?? appName;
      }

      LoadedMfeHelper.setLoadedApp(appName);
    }
  }

  static setLoadedApp(appName: string) {
    sessionStorage.setItem(LOADED_APP_KEY, appName);
  }

  static getLoadedApp(): string | null {
    const loadedApp = sessionStorage.getItem(LOADED_APP_KEY);
    return loadedApp;
  }

  static clearLoadedApp() {
    sessionStorage.removeItem(LOADED_APP_KEY);
  }

  /**
   * This ensures that we got a hold of the origin of the URL and persist it to the session storage for color management
   */
  static setLoadedAppFromCurrentLocation() {
    const loadedApp = LoadedMfeHelper.getLoadedApp();
    if (
      !loadedApp ||
      (loadedApp && !window.location.pathname.includes('session'))
    ) {
      LoadedMfeHelper.setLoadedApp(window.location.pathname.replace(/\//g, ''));
    }
  }
}
